import { getOmnichannelChannelTypeIcon } from 'flow/utils/omnichannel-utils';
import React from 'react';

interface OmnichannelIconProps {
    channelType: string;
}

const OmnichannelIcon = ({ channelType }: OmnichannelIconProps) => (
    <img src={getOmnichannelChannelTypeIcon(channelType)} alt={channelType} />
);

export default React.memo(OmnichannelIcon);
